const generateRandomRating = () => {
  const minRating = 1.0;
  const maxRating = 5.0;
  const randomValue = Math.random() * (maxRating - minRating) + minRating;
  const formattedValue = parseFloat(randomValue.toFixed(1)).toString();
  return formattedValue.replace('.', ',');
};
export default generateRandomRating;
